import React, { useState, useEffect } from 'react';
import Image from 'next/image';

interface CountMessageProps {
  onClose: () => void;
  recentBookingsCount: number;
}

const CountMessage: React.FC<CountMessageProps> = ({
  onClose,
  recentBookingsCount
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 50);
    }, 3000);

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, 500);
    }, 7000);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [onClose]);

  if (!shouldRender || recentBookingsCount === 0) return null;

  return (
    <div
      className={`fixed min-h-[84px] bottom-[75px] lg:bottom-4 left-4 bg-white shadow-xl rounded-lg p-4 w-[90%] max-w-[300px] z-[10000] border border-gray-200 transition-transform duration-500 ease-out ${
        isVisible ? 'translate-x-0' : '-translate-x-[calc(100%+16px)]'
      }`}
      style={{
        boxShadow: `
          8px 8px 10px rgba(0, 0, 0, 0.2),
          -1px -1px 1px rgba(0, 0, 0, 0.1)
        `
      }}
    >
      <button
        onClick={onClose}
        className="absolute top-2 right-[6px] cursor-pointer"
        aria-label="Close"
      >
        <Image
          src={'/close-icon.svg'}
          alt="close button"
          width={12}
          height={12}
        />
      </button>
      <div className="flex items-start h-full">
        <p className="text-left text-gray-800 font-medium pr-2">
          {recentBookingsCount}{' '}
          {recentBookingsCount === 1 ? 'person' : 'people'} booked this tour in
          the{' '}
          <span className="text-secondary font-extrabold">last 24 hours</span>
        </p>
      </div>
    </div>
  );
};

export default CountMessage;
